import { useEffect, useState } from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
import { ArrowUp } from 'lucide-react';

export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.3 });
  const [show, setShow] = useState(false);

  useEffect(() => {
    const f = () => setShow(window.scrollY > 700);
    f();
    window.addEventListener('scroll', f, { passive: true });
    return () => window.removeEventListener('scroll', f);
  }, []);

  return (
    <>
      <motion.div
        data-testid="scroll-progress"
        className="fixed top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-[#1FB6E9] via-[#38BDF8] to-[#7dd3fc] origin-left z-[70]"
        style={{ scaleX }}
      />
      {show && (
        <button
          data-testid="back-to-top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="fixed bottom-6 right-6 z-[60] w-12 h-12 rounded-full glass text-[#38BDF8] flex items-center justify-center hover:bg-[#1FB6E9] hover:text-[#06121f] hover:-translate-y-1 transition-all duration-200"
          aria-label="Back to top"
        >
          <ArrowUp className="w-5 h-5" />
        </button>
      )}
    </>
  );
};

export default ScrollProgress;
